import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/pt-br';

dayjs.extend(customParseFormat);

function formatAge(birthDate) {
  if (!birthDate) return '';
  const parsed = dayjs(birthDate, 'DD/MM/YYYY');
  if (!parsed.isValid()) return '';
  const years = dayjs().diff(parsed, 'year');
  return years === 1 ? '1 ano' : `${years} anos`;
}

// Groups of values the user can insert in a document, built from
// GET /patients/{patientId}/documents/data (fields come as null when not registered).
export function buildPatientDataGroups(data) {
  const patient = data?.patient;
  const responsible = data?.responsible;
  const professionalName = data?.professionalName;
  const professionalCouncil = data?.professionalCouncil;
  const clinicCity = data?.clinicCity;
  const today = dayjs().locale('pt-br');
  const longDate = today.format('D [de] MMMM [de] YYYY');

  return [
    {
      key: 'patient',
      label: 'Paciente',
      fields: [
        { key: 'name', label: 'Nome', value: patient?.name },
        { key: 'cpf', label: 'CPF', value: patient?.cpf },
        { key: 'rg', label: 'RG', value: patient?.rg },
        { key: 'birthDate', label: 'Data de nascimento', value: patient?.birthDate },
        { key: 'age', label: 'Idade', value: formatAge(patient?.birthDate) },
        { key: 'phone', label: 'Telefone', value: patient?.phone },
        { key: 'email', label: 'E-mail', value: patient?.email },
        { key: 'address', label: 'Endereço completo', value: patient?.address },
      ],
    },
    {
      key: 'responsible',
      label: 'Responsável',
      fields: [
        { key: 'responsibleName', label: 'Nome', value: responsible?.name },
        { key: 'responsibleCpf', label: 'CPF', value: responsible?.cpf },
        { key: 'responsiblePhone', label: 'Telefone', value: responsible?.phone },
        { key: 'responsibleKinship', label: 'Parentesco', value: responsible?.kinship },
      ],
    },
    {
      key: 'others',
      label: 'Outros',
      fields: [
        { key: 'today', label: 'Data atual', value: today.format('DD/MM/YYYY') },
        { key: 'todayLong', label: 'Data atual por extenso', value: longDate },
        {
          key: 'cityAndDate',
          label: 'Cidade e data',
          value: clinicCity ? `${clinicCity}, ${longDate}` : '',
        },
        { key: 'professional', label: 'Profissional', value: professionalName },
        {
          key: 'professionalWithCouncil',
          label: 'Profissional e CRO',
          value:
            professionalName && professionalCouncil
              ? `${professionalName} - ${professionalCouncil}`
              : '',
        },
      ],
    },
  ];
}
